import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaSelectModel, SmMetaTextAreaModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class UnassignInternshipMetaModel extends FormMetaModel {
    constructor() {
        super('', '', '', 7);
    }
    override initProperties(): any {
        const formInfo = super.initProperties();

        const internshipUnassignedReason = new SmMetaTextAreaModel(
            'internshipUnassignedReason',
            'internshipUnassignedReason',
            'SimpleTextarea',
            false,
            'col-12 ',
            1,
            2,
            '',
            'textarea',
            '',
            false,
            true,
            true,
            false,
            300,
            1,
            false,
            false,
            null,
            ''
        );

        const buttons = {
            submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
            isFormControl: false
        };

        return {
            formInfo,
            buttons,
            internshipUnassignedReason,
        }
}


}